import clsx from "clsx";

import { RequiredLabel } from "../../RequiredLabel";
import { LabelProps } from "./type";

export const Label = ({ htmlFor, required, children, fontSize = "md", tooltip }: LabelProps) => (
  <label
    htmlFor={htmlFor}
    className={clsx(
      "text-ui-500 flex items-center gap-2",
      fontSize === "sm" && "text-ui12 pb-[1px]",
      fontSize === "md" && "text-ui14 pb-2",
      fontSize === "lg" && "text-head16 pb-4",
    )}
  >
    {children}
    {required && <RequiredLabel />}
    {tooltip}
  </label>
);
